export enum EFunnelSettingsForm {
  name = 'name',
  projectName = 'projectName',
  image = 'image',
}
